<template>
    <div id="app" ref="app">
        <img class="position-relative" src="@/assets/img/9-years/top.jpg" alt="">
        <div class="position-relative">
            <img class="position-bg" src="@/assets/img/9-years/bg-2.jpg" alt="">
            <van-uploader :after-read="afterRead" class="show-modal-btn">
                <img src="@/assets/img/9-years/show-modal-btn.png" alt="">
            </van-uploader>
            <div class="list-frame">
                <img class="position-bg" src="@/assets/img/9-years/list.png" alt="">
                <div class="picture-list-frame">
                    <div v-if="listLoading" class="list-empty-text">作品加载中..</div>
                    <div v-if="!listLoading && list.length < 4" class="list-empty-text">暂无数据</div>
                    <div class="picture-list" v-if="!listLoading && list.length >= 4" ref="pictureList">
                        <div class="picture-item" v-for="(item, key) in list" :key="'item-' + key">
                            <img @click="showImage(key)" :src="item.url" alt="">
                            <div class="tool-bar">
                                <span class="nickname">{{ item.nickname }}</span>
                                <div class="like-button">
                                    <van-icon name="like" color="#fff" v-if="item.can_like" @click="like(item)"
                                        size="0.36rem" />
                                    <van-icon name="like" color="#b73335" size="0.36rem" v-else />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="position-relative">
            <img class="position-bg" src="@/assets/img/9-years/bg-3.jpg" alt="">
            <img class="random-btn" src="@/assets/img/9-years/random-btn.png" alt="" @click="get_picture_list">
            <div class="my-picture-gallery">
                <div v-if="myListLoading" class="list-empty-text">作品加载中..</div>
                <div v-if="!myListLoading && myList.length < 1" class="list-empty-text">暂无数据</div>
                <div class="my-picture-list" v-if="!myListLoading && myList.length > 0" ref="pictureList">
                    <div class="my-picture-item" v-for="(item, key) in myList" :key="'item-' + key">
                        <img @click="showMyImage(key)" :src="item.url" alt="">
                        <div class="tool-bar">
                            <span class="nickname">{{ item.nickname }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="position-relative">
            <img src="@/assets/img/9-years/bg-4.jpg" alt="">
        </div>
        <div class="award-record" @click="showAwardRecordModal = true">
            <img src="@/assets/img/9-years/award-record.png" alt="">
        </div>
        <transition name="fade">
            <modal :height="modalHeight" :width="modalWidth" v-if="showCreateModal" @closed="showCreateModal = false"
                @saveImage="saveMyPicture" />
        </transition>
        <h5-cropper ref="cropper" hide-input :option="option" @getbase64Data="getbase64Data"></h5-cropper>
        <van-image-preview v-model="showImagePreview" :images="images" @onChange="previewChange" :closeable="true"
            max-zoom="1" min-zoom="1" :startPosition="imageIndex">
            <template v-slot:cover>
                <div class="preview-like">
                    <span class="nickname">{{ list[imageIndex].nickname }}</span>
                    <div class="like-button">
                        <van-icon name="like" color="#fff" v-if="list[imageIndex].can_like"
                            @click="like(list[imageIndex])" />
                        <van-icon name="like" color="#b73335" v-else />
                        <span>{{ list[imageIndex].like_count }}</span>
                    </div>
                </div>
            </template>
        </van-image-preview>
        <van-image-preview v-model="showMyImagePreview" :images="myImages" @onChange="previewMyChange" :closeable="true"
            max-zoom="1" min-zoom="1" :startPosition="imageMyIndex">
        </van-image-preview>
        <transition name="slide-up">
            <awardRecordModal v-if="showAwardRecordModal" @closed="showAwardRecordModal = false"></awardRecordModal>
        </transition>
        <transition name="fade">
            <awardNoticeModal :prize="prize" v-if="showAwardNoticeModal" @closed="showAwardNoticeModal = false">
            </awardNoticeModal>
        </transition>
    </div>
</template>

<script>
import Vue from 'vue';
import { Toast, Uploader, ImagePreview, Icon } from 'vant';

// 全局注册
Vue.use(Icon);
Vue.use(ImagePreview);
Vue.use(Uploader);
import H5Cropper from "vue-cropper-h5";
import modal from './components/modal.vue'
import awardRecordModal from './components/award-record-modal.vue'
import awardNoticeModal from './components/award-notice-modal.vue'

export default {
    name: 'App',
    data() {
        return {
            prize: {},
            showAwardRecordModal: false,
            showAwardNoticeModal: false,
            images: [],
            myImages: [],
            modalWidth: "",
            modalHeight: "",
            showCreateModal: false,
            showImagePreview: false,
            showMyImagePreview: false,
            option: {
                outputType: "png",
                full: true,
                autoCrop: true,
                autoCropWidth: 1000,
                autoCropHeight: 1080,
                fixedBox: true,
                canScale: true,
            },
            listLoading: false,
            myListLoading: false,
            imageIndex: 0,
            imageMyIndex: 0,
            list: [],
            myList: [],
            colling: 0,
        }
    },
    methods: {
        getMyList() {
            if (parent.getAnimalMyList) {
                this.myListLoading = true;
                parent.getAnimalMyList().done((res) => {
                    this.myList = res
                    this.myImages = new Array();
                    if (this.myList.length > 0) {
                        const list = this.myList
                        for (let i = 0; i < list.length; i++) {
                            this.myImages.push(list[i]['url'])
                        }
                    }
                    this.myListLoading = false;
                })
            }
        },
        like(item) {
            item.can_like = false;
            item.like_count = parseInt(item.like_count) + 1;
            // 点赞的接口
            parent.animal2023Like(item.id).done((res) => {
                console.log(res)
            }).fail((res) => {
                console.log(res)
                item.can_like = true;
                item.like_count = item.like_count - 1;
            })
        },
        showImage(kk) {
            this.imageIndex = kk;
            this.showImagePreview = true;
            console.log(this.imageIndex)
        },
        showMyImage(kk) {
            this.imageMyIndex = kk;
            this.showMyImagePreview = true;
        },
        afterRead(file) {
            console.log('hello')
            this.$refs.cropper.loadBase64(file.content)
        },
        previewChange(index) {
            this.imageIndex = index;
        },
        previewMyChange(index) {
            this.imageMyIndex = index;
        },
        saveMyPicture(base64) {
            var loading = Toast.loading({
                position: 'middle',
                message: '上传中..',
                forbidClick: true,
            });

            if (!parent.uploadAnimalNewyearPicture) {
                Toast("请在社区内访问~")
                return false;
            } else {
                // 上传图片的接口
                parent.uploadAnimalNewyearPicture(base64).done((res) => {
                    Toast("发布成功~")
                    loading.clear();
                    if (res.status == 1) {
                        this.$set(this.list, 0, res)
                    }
                    this.showCreateModal = false;
                    // 上传照片获取成功
                    if (res && res.prize && res.prize.code) {
                        this.prize = res.prize
                        this.$nextTick(() => {
                            this.showAwardNoticeModal = true
                        })
                    }
                    this.getMyList()
                    document.body.style.overflow = '';
                }).fail((res) => {
                    console.log(res)
                    loading.clear();
                    document.body.style.overflow = '';
                })
            }

        },
        getbase64Data(data) {
            window.USER_CREATIVE_BG = data
            this.showCreateModal = true;
        },
        get_picture_list() {
            var curTime = (new Date()).getTime()
            if (curTime - 2000 <= this.colling) {
                Toast("您刷新的太频繁了~")
                return false;
            }
            this.colling = curTime
            this.listLoading = true;
            // 获取社区照片墙的接口
            if (parent.getAnimalNewyearList) {
                parent.getAnimalNewyearList().done((res) => {
                    this.list = res
                    this.images = new Array();
                    if (this.list.length > 0) {
                        for (let i = 0; i < this.list.length; i++) {
                            this.images.push(this.list[i]['url'])
                        }
                    }
                    console.log(this.images)
                    this.listLoading = false;
                })
            } else {
                Toast("请在社区内访问~")
                return false;
            }


        },
    },
    created() {

    },
    mounted() {
        var ratio = 1.4286;
        var realRatio = 0.9275;
        var width = this.$refs.app.clientWidth
        var height = document.documentElement.clientHeight
        if (height / width > ratio) {
            this.modalWidth = width * realRatio;
            this.modalHeight = this.modalWidth * ratio
        } else {
            this.modalHeight = height * realRatio;
            this.modalWidth = this.modalHeight / ratio;
        }
        this.get_picture_list();
        this.getMyList()
    },
    components: {
        modal,
        awardRecordModal,
        awardNoticeModal,
        H5Cropper
    }
}
</script>

<style>
.slide-up-enter-active,
.slide-up-leave-active {
    transition: all 0.5s ease-in-out;
}


.fade-enter-active,
.fade-leave-active {
    transition: all 0.5s ease-in-out;
}

/* create-page slide-up-enter-active slide-up-enter-to */
.slide-up-enter,
.slide-up-leave-to {
    transform: translateX(-50%) translateY(90vh) !important;
    background-color: #504ea9 !important;
    opacity: 0.8;
}

.fade-enter,
.fade-leave-to {
    background-color: #504ea9 !important;
    opacity: 0;
}

#app {
    width: 100%;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    max-width: 900px;
    margin: 0 auto;
    background: rgba(0, 0, 0, 0);
    -webkit-overflow-scrolling: touch;
    /* transform: translate(0, 0); */
}

body {
    margin: 0;
    padding: 0;
}

img {
    width: 100%;
    display: block;
}

.position-bg {
    position: relative;
    z-index: 1;
}

.position-relative {
    position: relative;
}

.show-modal-btn {
    position: absolute;
    width: 40%;
    z-index: 2;
    top: 0px;
    left: 50%;
    transform: translateX(-50%);
}

.random-btn {
    position: absolute;
    width: 40%;
    z-index: 2;
    top: 0px;
    left: 50%;
    transform: translateX(-50%);
}

.list-frame {
    position: absolute;
    width: 92.04%;
    z-index: 2;
    top: 1.2rem;
    left: 3.98%;
}

.redirect-topic {
    position: absolute;
    width: 43.70%;
    z-index: 2;
    bottom: 0.5rem;
    left: 28.15%;
}

.loading-modal {
    width: 100%;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    max-width: 900px;
    height: 100vh;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-items: center;
    align-content: center;
    position: fixed;
    top: 0px;
}

.my-picture-gallery {
    padding: 2px 0.5px;
    position: absolute;
    overflow: hidden;
    width: 70.5%;
    height: 45.4%;
    top: 33.2%;
    left: 15.4%;
    border-radius: 1%;
    z-index: 2;
}

.my-picture-gallery .list-empty-text {
    margin-top: 20px;
}

.picture-list-frame {
    width: 65.5%;
    height: 58.4%;
    top: 18.5%;
    left: 17.5%;
    position: absolute;
    z-index: 2;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
}

.picture-list {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
}

.my-picture-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: 48%;
    grid-column-gap: 2%;
    grid-row-gap: 2%;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
}

::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 1px;
}

::-webkit-scrollbar-thumb:vertical {
    border-radius: 8px;
    height: 100px;
    background-color: rgba(0, 0, 0, 0.8);
}

.picture-item {
    width: 48%;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
}

.my-picture-item {
    border-radius: 8px;
    overflow: hidden;
    position: relative;
}

.list-empty-text {
    text-align: center;
    font-size: 0.28rem;
    color: #464646;
}

.tool-bar {
    width: 100%;
    overflow: hidden;
    font-size: 0.18rem;
    color: #b73335;
    background-color: rgba(255, 255, 255, 0.5);
    position: absolute;
    bottom: 0px;
    display: flex;
    align-content: space-evenly;
    padding: 0.04rem 0.06rem;
    align-items: center;
    box-sizing: border-box;
}

.tool-bar .nickname {
    width: 62%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
    margin-right: auto;
    text-align: left;
}

.van-image-preview__cover {
    position: relative;
    top: 0;
    left: 0;
}

.preview-like {
    width: 100%;
    position: absolute;
    bottom: 0px;
    overflow: hidden;
    font-size: 0.36rem;
    color: #fff;
    display: flex;
    align-content: space-evenly;
    align-items: baseline;
    padding: 0.3rem;
    box-sizing: border-box;
}

.preview-like .nickname {
    margin-right: auto;
}

.like-button {
    display: flex;
    align-items: center;
}

.like-button .van-icon {
    margin-right: 0.06rem
}

.award-record {
    position: fixed;
    width: 1rem;
    height: 1rem;
    right: 10px;
    bottom: 20px;
    z-index: 10;
}

.award-record>img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>
